<script>
	// @ts-nocheck
	import '../app.css';
	// import { initDatadog, setUser, clearUser } from '#/lib/datadog';
	// initDatadog();
	import { SvelteToast } from '@zerodevx/svelte-toast';
	import { toastOptions } from '$lib/toast';
	import { goto } from '$app/navigation';
	import { page } from '$app/stores';
	import { browser } from '$app/environment';
	import { getAuthToken } from '$lib/auth.js';
	import { hydrateUserSession } from '$lib/session.js';
	import { onMount } from 'svelte';
	import { userStore } from '#/stores/user.svelte.js';
	import ToastAlert from '#/components/ui/Toast.svelte';
	import Topbar from '#/components/layout/Topbar.svelte';
	import { PT_MENU_CATEGORIES, normalizeSettingIds, getPTDefaultRoute } from '$lib/ptMenu.js';

	let { children } = $props();

	let checking = $state(true);
	const ptAllowedSettingIds = $derived(normalizeSettingIds($userStore?.settingIds));
	const ptAllowedPaths = PT_MENU_CATEGORIES.map((c) => c.href);

	function ptBasePathFor(path) {
		return ptAllowedPaths.find((p) => path.startsWith(p)) ?? '/letter_list';
	}

	const goToLoginIfNotLoggedIn = async () => {
		if (!browser) return;
		const token = getAuthToken();
		if (!token) {
			if (!$page.url.pathname.startsWith('/auth/')) goto('/auth/login');
			return;
		}

		let user;
		try {
			user = await hydrateUserSession();
		} catch (err) {
			if (/** @type {any} */ (err).status === 401) {
				if (!$page.url.pathname.startsWith('/auth/')) await goto('/auth/login');
				return;
			}
			throw err;
		}

		if ($page.url.pathname.startsWith('/auth/')) return;

		if (user?.type === 'PT') {
			const path = $page.url.pathname;
			const allowedSettingIds = normalizeSettingIds(user?.settingIds);
			const isAllowedList = ptAllowedPaths.some((p) => path.startsWith(p));
			if (!isAllowedList) {
				goto(await getPTDefaultRoute(user?.settingIds));
				return;
			}
			const segments = path.split('/');
			const taskId = segments[2];
			if (taskId && !allowedSettingIds.includes(taskId)) {
				goto(ptBasePathFor(path));
				return;
			}
		}

		if ($page.url.pathname.startsWith('/task_management')) {
			goto('/letter_list');
		}
	};

	onMount(async () => {
		await goToLoginIfNotLoggedIn();
		checking = false;
	});

	$effect(() => {
		const type = $userStore?.type;
		const path = $page.url.pathname;
		if (type === 'PT' && !path.startsWith('/auth/')) {
			const isAllowedList = ptAllowedPaths.some((p) => path.startsWith(p));
			if (!isAllowedList) {
				getPTDefaultRoute($userStore?.settingIds).then(goto);
			} else {
				const segments = path.split('/');
				const taskId = segments[2];
				if (taskId && !ptAllowedSettingIds.includes(taskId)) {
					goto(ptBasePathFor(path));
				}
			}
		}
		if (path.startsWith('/task_management')) {
			goto('/letter_list');
		}
	});

	const isAuthPage = $derived($page.url.pathname.startsWith('/auth/'));
</script>

<SvelteToast options={toastOptions} />

{#if isAuthPage}
	{@render children()}
{:else if checking}
	<div class="flex w-full h-screen items-center justify-center bg-neutral100">
		<span class="loading loading-spinner text-primary01"></span>
	</div>
{:else}
	<ToastAlert />
	<div class="flex flex-col w-full h-screen overflow-hidden">
		<Topbar />
		<main class="flex-1 overflow-auto mb-xl">
			{@render children?.()}
		</main>
	</div>
{/if}
